export type MarginableType = 'team' | 'margin-group';

export type MarginableTypeName = 'Team' | 'MarginGroup';

export type TransportMode = 'AIR' | 'OCEAN' | 'ROAD' | 'RAIL';

export type MarginApplication =
    | 'add_charge'
    | 'increase_amount'
    | 'increase_percent';

export type MarginAppliesType = 'all' | 'countries' | 'places';

export type ApplicationChargeBehavior = 'ignore' | 'add_charge' | null;

export interface Margin {
    id: string;
    marginable_type: MarginableType;
    marginable_type_name: MarginableTypeName;
    name: string;
    description: string;
    margin_rules: number;
    linked_teams: LinkedTeam[] | null;
    updated_at: string;
}

export interface Marginable {
    type: MarginableType;
    data: MarginableData;
    available_teams: LinkedTeam[] | null;
}

export interface MarginableData {
    id: string;
    name: string;
    rules: MarginRule[];
    linked_teams: LinkedTeam[] | null;
}

export interface MarginRule {
    id: number;
    transport_mode: TransportMode;
    load_type: string | null;
    application: MarginApplication;
    application_charge_behavior: ApplicationChargeBehavior;
    application_charge_id: number | null;
    application_charge_name: string | null;
    application_charge_segment: string | null;
    application_text: string | null;
    calculation: MarginCalculation;
    currency: string | null;
    rate: number;
    origin_applies_type: MarginAppliesType;
    origin_applies: string[];
    destination_applies_type: MarginAppliesType;
    destination_applies: string[];
    ratesource_scope: string[];
    additionals_scope: string[];
    deleting?: boolean;

    product?: string;
    charge_description?: string | null;
}

export interface MarginCalculation {
    id: number;
    name: string;
    description: string | null;
    is_percentage: boolean;
}

export interface LinkedTeam {
    id: string;
    name: string;
    address?: string;
}

export interface MarginIndexItem {
    id: string;
    marginable_type: MarginableType;
    marginable_type_name: MarginableTypeName;
    name: string;
    description: string;
    margin_rules: number;
    linked_teams: string[] | null;
    updated_at: string;
}

export interface CreateMarginGroupPayload {
    name: string;
    description?: string;
}

export interface UpdateMarginGroupPayload {
    name?: string;
    description?: string;
}

